module.exports = __webpack_public_path__ + "img/flusher_stopped.2e60dac1.svg";